import { defineComponent as _defineComponent } from 'vue'
import BCXButton from '@/components/molecules/BCXButton.vue';
import { PropType } from 'vue';
import { useVModel } from '@vueuse/core';
import { BCXExtendedDropdownItem } from '@/components/molecules/forms/BCXMultiselectSection.vue';
import toggleArrayItem from '@/utils/toggleArrayItem';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXFilterButtons',
  props: {
  value: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  items: {
    type: Array as PropType<BCXExtendedDropdownItem[]>,
    default: () => []
  },
  isExclusive: Boolean
},
  setup(__props) {

const props = __props;



const vmValue = useVModel(props);

const onClick = (value:string) => {
  if (props.isExclusive) vmValue.value = [value];
  else toggleArrayItem(vmValue.value, value);
};


return { __sfc: true,props, vmValue, onClick, BCXButton }
}

})